import * as ua from '@umu/umu-ua';
import { IShareConfig } from '@umu/umu-types';

import { WxShare } from './wxShare';
import { DingdingShare } from './dingdingShare';
import { BaseShare } from '../@share/baseShare';

/**
 * @file 微信 与 钉钉分享总入口
 * @author
 */

class Share {
    private shareConfig: IShareConfig = {} as IShareConfig;
    private platformShare: BaseShare | null = null;

    public getShareConfig() {
        if (this.platformShare) {
            return this.platformShare.getShareConfig();
        }
        return this.shareConfig;
    }

    public setup(config?: IShareConfig) {
        if (ua.isWeixinBrowser) {
            this.createWxShare(config);
        } else if (ua.isDingding) {
            this.createDingdingShare(config);
        }
    }

    private createWxShare(config?: IShareConfig) {
        this.platformShare = new WxShare();
        this.platformShare.setup(config as IShareConfig);
    }

    private createDingdingShare(config?: IShareConfig) {
        this.platformShare = new DingdingShare();
        this.platformShare.setup(config as IShareConfig);
    }
}

export default new Share();
